import { Urls } from './types';

export const replaceInPattern = (str: string, data: never) =>
  str.replace(/:([a-z]+)/gi, (pattern, key) => data[key]);

export const urlManager = {
  home: () => Urls.Home,
  signIn: () => Urls.SignIn,
  signUp: () => Urls.SignUp,
  signOut: () => Urls.SignOut,
  forgotPassword: () => Urls.ForgotPassword,
  recoveryPassword: () => Urls.RecoveryPassword,
  admin: () => ({
    root: () => Urls.Admin,
    users: () => Urls.AdminUsers,
  }),
};
